import "./App.css";
import React, { lazy, useState, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AllProductsTabs from "./pages/Tabs/AllProductsTabs";
import RawGoods from "./pages/RawGoodsEntry/RawGooodsEntry";
import PrivateRoute from "./privateroute";
import RolesPage from "./pages/CreateRoles/CreateRoles";
import ErrorPage from "./pages/404/ErrorPage";
import useAuth from "./context/useAuth";
import PdInventory from "./pages/Inventory/PdInventory";
import QcInventory from "./pages/Inventory/QcInventory";
import { Loader } from "./components/Loader";

// distributor
import DistributorLogin from "./pages/DistributorPages/DistributorLogin";
import DistributorStats from "./pages/DistributorPages/DistributorDashBoard";
import DistributorInventory from "./pages/DistributorPages/DistributorInventory";
import DistributorTransaction from "./pages/DistributorPages/DistributorTransaction";
import DistributorBilling from "./pages/DistributorPages/DistributorBilling";
import DistributorProductDetails from "./pages/DistributorPages/DistributorProductDetails";
import CreateRetaillor from "./pages/DistributorPages/CreateRetaillor";
import ShowRetailers from "./pages/DistributorPages/ShowRetaillers";
import DistributorTheme from "./pages/DistributorPages/DistributorTheme";
import PrivateDistributorRoute from "./PrivateDistributorRoute";
import RetailerDetails from "./pages/DistributorPages/RetailerDetails";
import ProductView from "./pages/WarrentyPage/ProductView";
import BrandWiseStock from "./pages/Brand-model/BrandWiseStock";
import ModelWiseStock from "./pages/Brand-model/ModelWiseStock";
import CustomCursor from "./components/f";
import CSV from "./components/CSV";
import WarrantyClaims from "./pages/WarrentyPage/AllWarrenty";
import SuperStockist from "./pages/AllRetailers/SuperStockist";

import SoldCSV from "./pages/Inventory/SoldCSV";
import CatBot from "./pages/CatBot/catbot";
const LoginPage = lazy(() => import("./pages/LoginPage/LoginPage"));
const Maincomp = lazy(() => import("./components/Maincomp/Maincomp"));
const SellingDetails = lazy(() =>
  import("./pages/SellingDetails/SellingDetails")
);
const Inventory = lazy(() => import("./pages/Inventory/Inventory"));
const CreateUserTab = lazy(() => import("./pages/Tabs/CreateUserTabs"));
const NewUserDetails = lazy(() =>
  import("./pages/NewUserDetails/NewUserDetails")
);
// const ProductDetails = lazy(()=> import('./pages/ProductDetails/ProductDetails'))
const ProductDetails2 = lazy(() =>
  import("./pages/ProductDetails/ProductDetails2")
);
const ProfileForm = lazy(() => import("./pages/ProfileForm/ProfileForm"));
const UserDetails = lazy(() => import("./pages/UserDetails/UserDetails"));
const Stats = lazy(() => import("./pages/Stats/Stats"));
const Toast = lazy(() => import("./components/common/Toast"));

const AllRetailer = lazy(() => import("./pages/AllRetailers/AllRetailers"));
const BillingPage = lazy(() => import("./pages/BillingPage/BillingPage"));

function App() {
  const { userPermissions = [], loading } = useAuth();

  const [toast, setToast] = useState({ visible: false, message: "" });

  console.log(userPermissions);

  const showToast = (message) => {
    setToast({ visible: true, message });
    setTimeout(() => setToast({ visible: false, message: "" }), 3000); // Auto-hide after 3 seconds
  };

  // console.log(userPermissions)

  const renderContent = (userPermissions) => {
    if (userPermissions.includes("Add Main Inventory")) {
      return <Inventory />;
    } else if (userPermissions.includes("Add Raw Inventory")) {
      return <PdInventory />;
    } else {
      return <ErrorPage />;
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      <div className="App">
        <CatBot />

        <CustomCursor />
        <Suspense fallback={<div>Loading Toast...</div>}>
          {toast.visible && (
            <Toast
              message={toast.message}
              onClose={() => setToast({ visible: false, message: "" })}
            />
          )}
        </Suspense>
        {/* Routes */}
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<LoginPage showToast={showToast} />} />

            <Route
              path="/stats"
              element={
                <PrivateRoute requiredPermissions={"Dashboard Access"}>
                  <Maincomp content={<Stats />} showToast={showToast} />
                </PrivateRoute>
              }
            />
            <Route
              path="/selling-details"
              element={
                <PrivateRoute requiredPermissions={"View Transactions"}>
                  <Maincomp
                    content={<SellingDetails />}
                    showToast={showToast}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/inventory"
              element={
                <Maincomp
                  content={renderContent(userPermissions)}
                  showToast={showToast}
                />
              }
            />
            <Route
              path="/inventory/:id"
              element={
                <Maincomp
                  content={renderContent(userPermissions)}
                  showToast={showToast}
                />
              }
            />
            <Route
              path="/all-inventory"
              element={
                <Maincomp content={<AllProductsTabs />} showToast={showToast} />
              }
            />
            <Route
              path="/create-user"
              element={
                <PrivateRoute requiredPermissions={"Create Users"}>
                  <Maincomp content={<CreateUserTab showToast={showToast} />} />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-user-details/:id"
              element={
                <PrivateRoute requiredPermissions={"Create Users"}>
                  <Maincomp
                    content={<NewUserDetails />}
                    showToast={showToast}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile-form"
              element={
                <PrivateRoute requiredPermissions={"Manage Roles"}>
                  <Maincomp content={<ProfileForm />} showToast={showToast} />
                </PrivateRoute>
              }
            />
            <Route
              path="/user-details"
              element={
                <PrivateRoute requiredPermissions={"Manage Roles"}>
                  <Maincomp content={<UserDetails />} showToast={showToast} />
                </PrivateRoute>
              }
            />
            <Route
              path="/product-details"
              element={
                <PrivateRoute requiredPermissions={"Search Product"}>
                  <Maincomp
                    content={<ProductDetails2 />}
                    showToast={showToast}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/product-details/:serial"
              element={
                <PrivateRoute requiredPermissions={"Search Product"}>
                  <Maincomp
                    content={<ProductDetails2 />}
                    showToast={showToast}
                  />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/all-products"
              element={
                <PrivateRoute requiredPermissions={"Search Product"}>
                  <Maincomp
                    content={<ProductDetails />}
                    showToast={showToast}
                  />
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/all-retailer"
              element={
                <PrivateRoute requiredPermissions={"Manage Roles"}>
                  <Maincomp
                    content={<AllRetailer isRetailer={true} />}
                    showToast={showToast}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/all-distributor"
              element={
                <PrivateRoute requiredPermissions={"Manage Roles"}>
                  <Maincomp
                    content={<AllRetailer isRetailer={false} />}
                    showToast={showToast}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/all-super-stockist"
              element={
                <PrivateRoute requiredPermissions={"Manage Roles"}>
                  <Maincomp content={<SuperStockist />} showToast={showToast} />
                </PrivateRoute>
              }
            />
            <Route
              path="/billing"
              element={
                <PrivateRoute requiredPermissions={"Billing"}>
                  <Maincomp content={<BillingPage />} showToast={showToast} />
                </PrivateRoute>
              }
            />
            {/* <Route path="/bill" element={<Invoice />} /> */}
            <Route path="/raw" element={<Maincomp content={<RawGoods />} />} />
            <Route
              path="/create-roles"
              element={
                <PrivateRoute requiredPermissions={"Create Users"}>
                  <Maincomp content={<RolesPage />} showToast={showToast} />
                </PrivateRoute>
              }
            />
            <Route
              path="/warranty"
              element={
                <PrivateRoute requiredPermissions={"Billing"}>
                  <Maincomp
                    content={<WarrantyClaims />}
                    showToast={showToast}
                  />
                </PrivateRoute>
              }
            />
            <Route
              path="/pv"
              element={
                <PrivateRoute requiredPermissions={"Billing"}>
                  <Maincomp content={<ProductView />} showToast={showToast} />
                </PrivateRoute>
              }
            />
            <Route path="/404" element={<ErrorPage />} />
            <Route
              path="/pd"
              element={
                <Maincomp content={<PdInventory />} showToast={showToast} />
              }
            />
            <Route
              path="/qc"
              element={
                <Maincomp content={<QcInventory />} showToast={showToast} />
              }
            />

            {/* Distributor Routes */}
            <Route path="/distributor/login" element={<DistributorLogin />} />
            <Route
              path="/distributor/stats"
              element={
                <PrivateDistributorRoute>
                  {" "}
                  <DistributorTheme content={<DistributorStats />} />{" "}
                </PrivateDistributorRoute>
              }
            />
            <Route
              path="/distributor/inventory"
              element={
                <PrivateDistributorRoute>
                  {" "}
                  <DistributorTheme content={<DistributorInventory />} />{" "}
                </PrivateDistributorRoute>
              }
            />
            <Route
              path="/distributor/transaction"
              element={
                <PrivateDistributorRoute>
                  {" "}
                  <DistributorTheme content={<DistributorTransaction />} />{" "}
                </PrivateDistributorRoute>
              }
            />
            <Route
              path="/distributor/ProductDetails"
              element={
                <PrivateDistributorRoute>
                  {" "}
                  <DistributorTheme
                    content={<DistributorProductDetails />}
                  />{" "}
                </PrivateDistributorRoute>
              }
            />
            <Route
              path="/distributor/billing"
              element={
                <PrivateDistributorRoute>
                  {" "}
                  <DistributorTheme content={<DistributorBilling />} />{" "}
                </PrivateDistributorRoute>
              }
            />
            <Route
              path="/distributor/create-retaillor"
              element={
                <PrivateDistributorRoute>
                  {" "}
                  <DistributorTheme
                    content={<CreateRetaillor showToast={showToast} />}
                  />{" "}
                </PrivateDistributorRoute>
              }
            />
            <Route
              path="/distributor/show-retaillers"
              element={
                <PrivateDistributorRoute>
                  <DistributorTheme content={<ShowRetailers />} />{" "}
                </PrivateDistributorRoute>
              }
            />
            <Route
              path="/distributor/retailers-details/:id"
              element={
                <PrivateDistributorRoute>
                  <DistributorTheme content={<RetailerDetails />} />{" "}
                </PrivateDistributorRoute>
              }
            />

            <Route path="/all-brands" element={<BrandWiseStock />} />
            <Route path="/all-models" element={<ModelWiseStock />} />

            <Route path="/export-csv" element={<CSV />} />
            <Route path="/sold-csv" element={<SoldCSV/>} />

          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}
export default App;
